/**
 * The available ypes of authentication.
 * @public
 */
export var AuthType;
(function (AuthType) {
    AuthType["BASIC"] = "BASIC";
    AuthType["SSO"] = "SSO";
    AuthType["JWT"] = "JWT";
    AuthType["REFRESH"] = "REFRESH";
})(AuthType || (AuthType = {}));
/**
 * Represents an error that occurs during authentication.
 * @public
 */
export class AuthError extends Error {
    constructor(sent, received, message = 'Auth Failed \n') {
        super(message);
        this.sent = sent;
        this.received = received;
        Object.setPrototypeOf(this, AuthError.prototype);
    }
    // Add known edge cases...
    isIgnorableError() {
        var _a, _b, _c, _d;
        // TODO: This is really ugly, lets figure out if this is still an issue and remove if not
        return (_d = (_c = (_b = (_a = this.received) === null || _a === void 0 ? void 0 : _a.DETAILS) === null || _b === void 0 ? void 0 : _b.ERROR) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes('request needs the user to be logged'); // out or in
    }
    getMessageError() {
        var _a, _b;
        return Array.isArray((_a = this.received) === null || _a === void 0 ? void 0 : _a.ERROR)
            ? (_b = this.received) === null || _b === void 0 ? void 0 : _b.ERROR.map((error) => this.errorDetailFormatter(error)).join('\n')
            : '';
    }
    getDetailsError() {
        var _a, _b, _c, _d;
        return Array.isArray((_b = (_a = this.received) === null || _a === void 0 ? void 0 : _a.DETAILS) === null || _b === void 0 ? void 0 : _b.ERROR)
            ? (_d = (_c = this.received) === null || _c === void 0 ? void 0 : _c.DETAILS) === null || _d === void 0 ? void 0 : _d.ERROR.map((error) => this.errorDetailFormatter(error)).join('\n')
            : '';
    }
    hasPasswordExpiredError() {
        return this.hasErrorCode('PASSWORD_EXPIRED');
    }
    hasMFAError() {
        return this.hasErrorCode('MFA_REQUIRED');
    }
    hasErrorCode(code) {
        var _a, _b;
        return Array.isArray((_a = this.received) === null || _a === void 0 ? void 0 : _a.ERROR)
            ? (_b = this.received) === null || _b === void 0 ? void 0 : _b.ERROR.some((error) => error.CODE === code)
            : false;
    }
    errorDetailFormatter(error) {
        return `\n ${error.CODE}: \n ${error.TEXT}`;
    }
}
